import {
  LIVE_GROUPS,
  BUNDLE_BANNERS,
  TOKENS,
  TOKEN_PACKS,
  WEB_SUBSCRIPTION_GROUPS,
  MINI_CLASSES,
} from '@dragonfruit/constants/premiumPage';

export const FETCH_PREMIUM_PAGE = 'FETCH_PREMIUM_PAGE';
export const FETCH_PREMIUM_PAGE_SUCCESS = 'FETCH_PREMIUM_PAGE_SUCCESS';
export const FETCH_PREMIUM_PAGE_FAILURE = 'FETCH_PREMIUM_PAGE_FAILURE';

const PREMIUM_INIT_STATE = {
  structureDataList: [],
  sections: [],
  bundleBanners: [],
  tokens: [],
  tokenPacks: [],
  webSubscriptionGroupMapping: {},
  liveGroups: {},
  miniClasses: [],
};

export const fetchPremiumPage = payload => ({
  type: FETCH_PREMIUM_PAGE,
  payload,
});

export const fetchPremiumPageSuccess = payload => ({
  type: FETCH_PREMIUM_PAGE_SUCCESS,
  payload,
});

export const fetchPremiumPageFailure = payload => ({
  type: FETCH_PREMIUM_PAGE_FAILURE,
  payload,
});

const reducer = (state = PREMIUM_INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_PREMIUM_PAGE:
      return { ...state };

    case FETCH_PREMIUM_PAGE_SUCCESS:
      return { ...state, ...action.payload };

    case FETCH_PREMIUM_PAGE_FAILURE:
      return { ...state };

    default:
      return state;
  }
};

export default reducer;

export function transformBundleBannerData(rawData) {
  const { imageUrl, url } = rawData;

  return {
    imageUrl,
    url,
  };
}

export function transformPlanData(rawData) {
  const {
    name,
    longDescription: description,
    questionQuota: quota,
    currency,
    displayCurrency,
    designatedQuestion,
    isFocus,
    planType,
    highlight,
    isContract,
    contractPeriod,
    billingCyclePerMonths,
    hasMorePlans,
    paymentMethods: [{ id: paymentMethodId = '', price = 0, sku = '' } = {}],
  } = rawData;
  return {
    name,
    description,
    planType,
    highlight: isFocus ? highlight : '',
    quota,
    currency,
    displayCurrency,
    price,
    designatedQuestion,
    hasMorePlans,
    billingCyclePerMonths,
    isContract,
    contractPeriod,
    paymentMethodId,
    sku,
  };
}

export function transformPlanGroupData(rawData) {
  const {
    title: name,
    description,
    highlight,
    lowestPlanPrice,
    plans,
  } = rawData;

  return {
    name,
    description,
    highlight,
    lowestPlanPrice: +lowestPlanPrice,
    plans: plans.map(plan => transformPlanData(plan)),
  };
}

export function transformLiveGroupData({
  storePagePictures,
  planBillingCycleGroups,
}) {
  const [{ plans = [] } = {}] = planBillingCycleGroups;

  const pictureGroups = storePagePictures.reduce(
    (acc, picture, index) => {
      const groupLength = acc.length;
      const groupIndex = index % groupLength;

      acc[groupIndex].push(picture);
      return acc;
    },
    [[], [], []]
  );

  return {
    pictureGroups,
    // get the first 2 plans as yearly and monthly plan.
    planGroups: plans.slice(0, 2).map(transformPlanData),
  };
}
export const transformFunctionMapping = {
  [LIVE_GROUPS]: rawData => {
    return transformLiveGroupData(rawData);
  },
  [WEB_SUBSCRIPTION_GROUPS]: rawData => {
    const planGroups = rawData.reduce(
      (acc, { contractPeriod, plans }) => ({
        ...acc,
        [contractPeriod]: plans.map(plan => transformPlanData(plan)),
      }),
      {}
    );

    return {
      planGroups,
      planGroupKeys: Object.keys(planGroups).map(key => +key),
    };
  },
  [BUNDLE_BANNERS]: rawData =>
    rawData.map(data => transformBundleBannerData(data)),
  [TOKENS]: rawData => rawData.map(data => transformPlanData(data)),
  [TOKEN_PACKS]: rawData =>
    rawData.map(tokenPack => transformPlanGroupData(tokenPack)),
  [MINI_CLASSES]: rawData => rawData.map(data => transformPlanData(data)),
};

export function transformPremiumPageData(sectionName, rawData) {
  if (!rawData) return;
  const transFormFunction = transformFunctionMapping[sectionName];

  return transFormFunction(rawData);
}



// WEBPACK FOOTER //
// ./app/redux/premiumPage.js